import Cookies from "js-cookie";
import axios from "./config";
import { jwtDecode } from "jwt-decode";

interface DecodedToken {
  emp_id: string;
}

export function getHeader() {
  const token = Cookies.get("token") || "";
  const header = {
    Authorization: token,
  };
  return header;
}

const getUserInfo = () => {
  const token = Cookies.get("token");

  if (!token) {
    throw new Error("Authorization token not found");
  }

  return jwtDecode<DecodedToken>(token);
};

export const getAllMapping = async (
  page: number,
  size: number,
  params: any
): Promise<any> => {
  let url = "";
  if (params.search)
    url = `/admin/storage-location-mappings?page=${page}&size=${size}&emp_id=${params.search}`;
  else
    url = `/admin/storage-location-mappings?page=${page}&size=${size}`;

  const response = await axios.post<any>(
    url,
    {}, // empty POST body
    {
      headers: getHeader(), 
    }
  );

  return response.data;
};


export const deleteMapping = async (id: number): Promise<any> => {
  let url = `/admin/storage-location-mappings/${id}`;
  const response = await axios.delete<any>(url, {
    headers: getHeader(),
  });
  return response.data;
};

export const addnewMapping = async (formData: any): Promise<any> => {
  let url = `/admin/storage-location-mappings/create`;
  const response = await axios.post<any>(url, formData, {
    headers: getHeader(),
  });
  return response.data;
};

export const activate = async (formData: any): Promise<any> => {
  let url = `/admin/employee-activation`;
  const response = await axios.post<any>(url, formData, {
    headers: getHeader(),
  });
  return response.data;
};

export const getAvailableStorageLocations = async (): Promise<any> => {
  let url = `/admin/storage-location-mappings/available`;
  const response = await axios.get<any>(url, {
    headers: getHeader(),
  });
  return response.data;
};